
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import lazyInject from '@/di';
import CarService from '@/services/car.service';
import PartialRefoundPopover from './components/PartialRefundPopover.vue';
import CAROrderRemarkModal from './components/CAROrderRemarkModal.vue';
import CarSalesmanChange from './components/CarSalesmanChange.vue';
import CarUploadPaymentOrderNo from './components/CarUploadPaymentOrderNo.vue';
import CarGiveOrderDuration from './components/CarGiveOrderDuration.vue';
import { AuthEnum } from '@/services/permission.service';
import CarPaymentDrawer from './components/CarPaymentDrawer.vue';

@Component({
  components: {
    PartialRefoundPopover,
    CAROrderRemarkModal,
    CarSalesmanChange,
    CarUploadPaymentOrderNo,
    CarGiveOrderDuration,
    CarPaymentDrawer,
  },
})
export default class OrderBListNotPay extends Vue {
  @lazyInject(CarService)
  carService!: CarService;

  @Ref('carOrderRemarkModal')
  carOrderRemarkModal!: CAROrderRemarkModal;

  @Ref('carSalesmanChange')
  carSalesmanChange!: CarSalesmanChange;

  @Ref('carUploadPaymentOrderNo')
  carUploadPaymentOrderNo!: CarUploadPaymentOrderNo;

  @Ref('carPaymentDrawer')
  carPaymentDrawer!: CarPaymentDrawer;

  giveOrderVisible = false;

  AuthEnum = AuthEnum;

  packagesList: any = [];

  labelList: any = [
    {
      value: 2,
      table: '二手车',
    },
    {
      value: 3,
      table: '车务代理',
    },
    {
      value: 4,
      table: '汽车配件',
    },
  ];

  cacheNo = '';
  refresh() {
    // console.log('刷新');
  }
  listData = [];

  form: any = {
    regionId: '',
    shopName: '',
    poi: '',
    staff: '',
    payStatus: 0,
    orderNo: '',
    orderId: '',
    kaId: undefined,
    packageId: undefined,
    labelId: undefined,
    payChannel: '',
  };

  currentOrder: any = '';

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.pageChange,
  };

  @Watch('$route')
  handleSearch() {
    const {
      regionId,
      shopName,
      poi,
      staff,
      orderNo,
      orderId,
      packageId,
      labelId,
      payChannel,
      pageSize,
      page,
      kaId,
    } = this.$route.query;
    const query: { [key: string]: any } = {
      page: page || 1,
      pageSize,
    };
    if (regionId) {
      query.region_id = regionId;
      this.form.regionId = regionId;
    }
    if (shopName) {
      query.shop_name = shopName;
      this.form.shopName = shopName;
    }
    if (poi) {
      query.poi = poi;
    }
    if (staff) {
      query.staff = staff;
      this.form.staff = staff;
    }
    if (orderNo) {
      query.order_no = orderNo;
      this.form.orderNo = orderNo;
    }
    if (orderId) {
      query.order_id = orderId;
      this.form.orderId = orderId;
    }
    if (packageId) {
      query.package_id = +packageId;
      this.form.packageId = +packageId;
    }
    if (labelId) {
      query.label_id = +labelId;
      this.form.labelId = +labelId;
    }
    if (payChannel) {
      query.pay_channel = payChannel;
      this.form.payChannel = payChannel;
    }
    if (kaId) {
      query.ka_id = kaId;
      this.form.kaId = +kaId;
    }
    query.pay_status = 0;
    this.getList(query);
  }

  datyClose() {
    this.giveOrderVisible = false;
    this.handleSearch();
  }

  async getPackages() {
    const res = await this.carService.shopOrderPackages();
    this.packagesList = res;
  }

  copyToClipboard(item: any) {
    this.$copyText(String(item)).then(
      () => {
        this.$message.success('复制成功');
      },
      (err) => {
        this.$message.error(`复制失败:${err}`);
      },
    );
  }

  changeLabelId(id: number) {
    switch (id) {
      case 2:
        return '二手车';
      case 3:
        return '车务代理';
      case 4:
        return '汽车配件';
      default:
        return '';
    }
  }

  openRemarkModal(orderNo: string, text = '') {
    this.carOrderRemarkModal.open({
      type: 'BOrder',
      title: '追加备注',
      orderNo: `${orderNo}`,
      text,
    });
  }

  pageChange(page: number, pageSize: number) {
    // console.log(page, pageSize);
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.changeQuery();
  }

  openUploadPaymentOrderNoModal(order: any) {
    // console.log(order);
    // this.carUploadPaymentOrderNo.open(order);
    this.carPaymentDrawer.init(order);
  }

  search() {
    this.pagination.current = 1;
    this.changeQuery();
  }
  reset() {
    this.pagination.current = 1;
    const { pageSize } = this.pagination;
    const query: { [key: string]: any } = {
      timestamp: `${Math.round(Date.now() / 1000)}`,
      page: 1,
      pageSize,
    };
    this.form = {
      regionId: '',
      shopName: '',
      poi: '',
      staff: '',
      payStatus: 0,
      orderNo: '',
      orderId: '',
      kaId: undefined,
      packageId: undefined,
      labelId: undefined,
      payChannel: '',
    };
    this.$router.push({
      query,
    });
  }

  changeQuery() {
    const {
      regionId,
      shopName,
      poi,
      staff,
      payStatus,
      orderNo,
      orderId,
      packageId,
      labelId,
      payChannel,
      kaId,
    } = this.form;
    const { current, pageSize } = this.pagination;
    const query: { [key: string]: any } = {
      timestamp: `${Math.round(Date.now() / 1000)}`,
      page: current,
      pageSize,
    };
    if (regionId) {
      query.regionId = regionId;
    }
    if (shopName) {
      query.shopName = shopName;
    }
    if (poi) {
      query.poi = poi;
    }
    if (payStatus) {
      query.payStatus = payStatus;
    }
    if (staff) {
      query.staff = staff;
    }
    if (orderNo) {
      query.orderNo = orderNo;
    }
    if (orderId) {
      query.orderId = orderId;
    }
    if (packageId) {
      query.packageId = packageId;
    }
    if (labelId) {
      query.labelId = labelId;
    }
    if (payChannel) {
      query.payChannel = payChannel;
    }
    if (kaId) {
      query.kaId = kaId;
    }
    this.$router.push({
      query,
    });
  }

  /** 赠送时长 */
  give(no: string) {
    // console.log('sssss');
    this.cacheNo = no;
    this.giveOrderVisible = true;
  }

  openSalesmanChange(order: any) {
    // console.log(order);
    this.currentOrder = order;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.carSalesmanChange.open();
  }

  closeSalesmanChange() {
    this.currentOrder = null;
  }
  async getList(query: any) {
    const res = await this.carService.auditEditShopOrder(query, this.$el);
    if (res) {
      this.listData = res.list;
      this.pagination.total = res.total;
      this.pagination.current = res.page;
    }
  }

  kalist: any[] = [];

  async getKaList() {
    const response = await this.carService.getCarKaAll();
    if (response) {
      this.kalist = response;
    }
  }
  mounted() {
    this.handleSearch();
    this.getPackages();
    this.getKaList();
  }
}
